module.exports = __webpack_public_path__ + "static/media/qb.fb5e0bce.png";